import React from 'react'

/**
 * 레퍼런스(hanwha_scouting_view의 `components/layout/Footer.jsx`) 포팅.
 *
 * 레퍼런스는 페이지 전체가 스크롤되는 구조라 푸터가 본문 아래로 밀려나지만, 이 프로젝트는
 * `height:100vh + overflow:hidden` 셸에 본문만 내부 스크롤하는 구조다(CLAUDE.md "레이아웃 구조" 참고).
 * 그래서 푸터가 항상 화면에 보이게 되므로, 같은 문구를 유지하면서 3줄 → 2줄로 압축해 높이를 줄였다.
 */

const FOOTER_LINKS = ['이용약관', '묻고답하기(FAQ)', '1:1문의하기', '사업제휴', '이메일무단수집거부']

const COMPANY_INFO = [
  '상호명 : 하이볼(주)',
  '대표 : 김재승',
  '주소 : 경상남도 창원시 의창구 용동로57번길 18, 901호(사림동, 시그니처M)',
  '우편번호 : 51139',
  '대표전화 : 055-289-0351',
  'FAX : 055-289-0350',
]

const AppFooter: React.FC = () => (
  <footer
    style={{
      borderTop: '1px solid #E5E7EB',
      background: '#F9FAFB',
      padding: '10px 24px',
      textAlign: 'center',
      flexShrink: 0,
    }}
  >
    <div
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        gap: '4px 16px',
        marginBottom: 6,
      }}
    >
      {FOOTER_LINKS.map((label) => (
        <a
          key={label}
          href="#"
          onClick={(e) => e.preventDefault()}
          style={{ fontSize: 12, color: '#6B7280', textDecoration: 'none' }}
        >
          {label}
        </a>
      ))}
    </div>

    <div
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        gap: '2px 12px',
        fontSize: 11,
        color: '#9CA3AF',
      }}
    >
      {COMPANY_INFO.map((info) => (
        <span key={info}>{info}</span>
      ))}
      <span style={{ color: '#C4C9D2' }}>COPYRIGHT ⓒ 2017 by hiball. ALL RIGHTS RESERVED.</span>
    </div>
  </footer>
)

export default AppFooter
